// extracted by css-extract-rspack-plugin
export default {"zoomOverlay":"tFL8K"};